import { StatusType } from '@oy/types';
import { FormSchema } from 'src/hooks';

export enum ClaimFundFilterFieldName {
  StartDate = 'created_after',
  EndDate = 'created_before',
  PartnerTransactionId = 'partner_tx_id',
  Amount = 'amount',
  RecipientName = 'recipient_name',
  Status = 'status',
  SearchKey = 'search_key',
  ProductName = 'product_name',
}

export const CLAIM_FUND_FILTER_SCHEMA: FormSchema = {
  [ClaimFundFilterFieldName.PartnerTransactionId]: {
    initialValue: '',
    validationRule: 'string',
  },
  [ClaimFundFilterFieldName.RecipientName]: {
    initialValue: '',
    validationRule: 'string',
  },
  [ClaimFundFilterFieldName.StartDate]: {
    initialValue: '',
    validationRule: 'present',
  },
  [ClaimFundFilterFieldName.EndDate]: {
    initialValue: '',
    validationRule: 'present',
  },
  [ClaimFundFilterFieldName.Amount]: {
    initialValue: '',
    validationRule: 'present',
  },
  [ClaimFundFilterFieldName.Status]: {
    initialValue: '',
    validationRule: 'present',
  },
  [ClaimFundFilterFieldName.SearchKey]: {
    initialValue: '',
    validationRule: 'string',
  },
  [ClaimFundFilterFieldName.ProductName]: {
    initialValue: '',
    validationRule: 'string',
  },
};

export const CLAIM_LIST_STATUSES: StatusType[] = [
  'EXPIRED',
  'FAILED',
  'IN_PROGRESS',
  'INITIATED',
  'REJECTED',
  'SUCCESS',
  'WAITING_APPROVAL',
];

export const CLAIM_FUND_DETAIL_URL = '/disbursement/claim-fund/detail/';
export const CLAIM_FUND_CREATE_URL = '/disbursement/claim-fund/create';
